import React, {useState} from 'react'
import {Form, InputNumber, Switch, Button, Input, Upload, Image, Row, Col} from 'antd'
import { createBlog } from '../../api/blog';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import storage from '../../shared/storage'
import Loader from '../../shared/loaderImg';
import {MdClose, MdDelete} from 'react-icons/md'
import styled from 'styled-components'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import {useHistory} from "react-router-dom";
import { useDispatch } from 'react-redux';
import ReactQuill from 'react-quill';

const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const tailLayout = {
    wrapperCol: {
      offset: 4,
      span: 16,
    },
  };


export default function AddSocialCoupon() {
  const history = useHistory();
    const dispatch = useDispatch();
    const [imgurl, setImgurl] = useState([])
    const [loading1, setLoading1] = useState(false)
    const [fileList, setFileList] = useState([])
    const [blog, setBlog] = useState("");


    const onFinish = (values) => {

    const data = {

      title:values.title,
      image: imgurl[0],
      sub_title:values.sub_title , 
      description:blog ,
      author:values.author ,

    }
    console.log({data});
        dispatch(createBlog(data))
        history.goBack()
      
      };




      const handleChange = info => {
        setLoading1(true)
           
            storage
            .ref("images/" + info.file.name)
            .put(info.file.originFileObj)
            .then(snapshot => {
              return snapshot.ref.getDownloadURL();
            })
            .then(url => {
              setImgurl([...imgurl, url])
              setLoading1(false)
            })
            .catch(error => {
              console.log({error});
            });
        
          };



          const remove = (e, url) =>{
    
            setImgurl(prev => prev.filter(item => item !== url))
            
            }
        
          const uploadButton = (
            <div>
              { loading1 ? <LoadingOutlined  /> : <PlusOutlined />}
              <div style={{ marginTop: 8, fontSize:"14px" }}>{loading1 ? "uploading" :""}</div>
            </div>
          );
            

         
      
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
    
      const [form] = Form.useForm();
    
      const onChange = (value)=> {
        console.log(`selected ${value}`)
    
      }
    

     const modules = {
        toolbar: [
          [{ 'font': [] }],
          [{size: []}],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
          ['link', 'image'],
          ['clean']
        ],
      }
    
      const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
      ]

        

    return (
      <FormWrap>

      <Form
      {...layout}
  
      name="basic"
      initialValues={{ remember: true }}
    
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      className="mt-4"
    >


<Form.Item
        label="Blog Title"
        name="title"
      >
        <Input className=" text-capitalize"  />

      </Form.Item>


      <Form.Item
            label={<p className="text-left m-0 ml-2 ">Blog Image</p>}
            name="image"
            // rules={[{ required: true, message: 'required!' }]}
          >
                          <Row gutter={10}>
            <Col span={5}>
                {

                imgurl.map((img, i)=>{

                  return <div className=" imglist " style={{height:"100px"}}>
                   
                  <Image    
                   preview={false}               
                   key={i}
                   style={{height:"100%", width:"100%", borderRadius: '0.25rem', display:'block', objectFit:'cover'}}
                   src={img}
                   placeholder={<Loader/> }              
                 />   

                  <h2 onClick={(e)=>remove(e, img)} className=" text-white  "> <MdDelete/></h2> 

                    </div>
                })
              }
              </Col>

                <Upload       
                        listType="picture-card"
                        fileList={fileList}
                        onChange={handleChange}
                        multiple={true}
                        style={{marginLeft:'0.5rem'}}
                        >
                        {imgurl.length >= 1 ? null : uploadButton}
                        </Upload>
                </Row>

        </Form.Item>

        <Form.Item
        label=" Sub title"
        name="sub_title"
      >
        <Input className=" text-capitalize"  />

      </Form.Item>

       
      <Form.Item
        label="Author"
        name="author"
      >
        <Input className=" text-capitalize"  />

      </Form.Item>

      <Form.Item
        label="Description"
        name="description"
        // rules={[
        //   {
        //     required: true,
        //     message: 'required!',
        //   },
        // ]}
      >
        <>
         <ReactQuill 
         theme="snow" 
         value={blog} 
         modules={modules}
         formats={formats}
         onChange={setBlog} />
         </>
      </Form.Item>  


   
 
     
      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
   </FormWrap>
    )
}



const FormWrap = styled.div`
position: relative;

.imglist {
overflow: hidden;
background-color: #f1f1f1;
text-align: center;


h2 { opacity : 0;
display:none;
position: absolute;
margin: 0;
bottom: 1%;
background-color: rgba(0,0,0,0.5);
cursor: pointer;
transition: 0.1s;

&:hover {

font-size: 1.5rem;
}

}

&:hover h2 {

opacity : 1;
display:block
}
}

`